import Vue from 'vue'

export const GLOBAL_ADDRESS_CHANGE = 'GLOBAL_ADDRESS_CHANGE' // 地址发生了改变
export const ORDER_DETAIL_REFRESH = 'ORDER_DETAIL_REFRESH' // 地址发生了改变
export const GET_STEPPER_POSITION = 'GET_STEPPER_POSITION' // 获取计步器的位置
export const OPEN_THE_SHOPPING_BAG = 'OPEN_THE_SHOPPING_BAG' // 打开购物袋

export const eventBus = new Vue()
